// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__3EB9Y","modal":"Modal_modal__P3_V5","buttonsContainer":"Modal_buttonsContainer__1_XeL","button":"Modal_button__2O7k8"};